/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getDateRange = (params) => makeApiCall(`/daily-report/date-range`, 'POST', params);

export const getDailyManagerDashboard = (params) => makeApiCall(`/daily-report`, 'POST', params);

export const getDailyManagerDashboardTotal = (params) =>
  makeApiCall(`/daily-report/total`, 'POST', params);

export const getManagerDashboardWorkingRerport = (params) =>
  makeApiCall(`/daily-report/working-report`, 'POST', params);

export const getFocusGroup = (params) => makeApiCall(`/user/focus-groups`, 'GET', params);

export const getExportManagerDashboard = (params) =>
  makeApiCall(`/daily-report/export`, 'POST', params);

export const getExportPlannedExecution = (params) =>
  makeApiCall(`/daily-report/plan-execution/export`, 'POST', params);

export const getAdvanceReceivedDetails = (params) =>
  makeApiCall(`/daily-report/details`, 'POST', params);
